import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
});

console.log(process.env);

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');

    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => {
    response = response.data;
    return response;
  },
  async (error) => {
    return Promise.reject(error.response.data);
  }
);

const { get, post, put } = apiClient;
const destroy = (url, config) => apiClient.delete(url, config);

export { get, post, put, destroy };